const createFullSize = imageWrapper => {
    const imageEl = imageWrapper.querySelector('svg, img');
    if (!imageEl) {
        return;
    }

    const fullSizeIcon = document.createElement('a');
    fullSizeIcon.className = 'floating ui label basic button';
    fullSizeIcon.innerText = 'Actual size';
    fullSizeIcon.target = '_blank';
    fullSizeIcon.rel = 'noopener';

    if (imageEl instanceof HTMLImageElement) {
        fullSizeIcon.href = imageEl.src;
    } else {
        fullSizeIcon.href = URL.createObjectURL(new Blob([imageEl.outerHTML], {type: 'image/svg+xml'}));
    }

    return fullSizeIcon;
}

export const imageWrapper = imageElement => {
    const imageWrapper = document.createElement('div');
    imageWrapper.className = 'ui image';
    if (typeof imageElement === 'string') {
        imageWrapper.innerHTML = imageElement;
    } else {
        imageWrapper.appendChild(imageElement.cloneNode(true));
    }

    const fullSize = createFullSize(imageWrapper);
    if (!imageWrapper.querySelector('.ui.right.attached.label')) {
        imageWrapper.addEventListener('mouseover',
            () => imageWrapper.insertAdjacentElement('beforeend', fullSize));
    }
    imageWrapper.addEventListener('mouseleave',
        () => imageWrapper.removeChild(fullSize));

    return imageWrapper;
}